import devicesService from "@/services/devices";
import router from "../../router/index";

const getDefaultState = () => {
  return {
    loading: false,
  };
};

export const state = getDefaultState();

export const actions = {
  addDevice({ commit, dispatch }, params) {
    commit("setLoading", true);
    return new Promise((resolve, reject) => {
      devicesService
        .addDevice(params)
        .then((data) => {
          resolve(data);
          this._vm.$toast.success("Door Added");
          dispatch("sites/fetchAreasFilter", { id: router.history.current.params.id }, { root: true });
          commit("modal/setModalState", true, { root: true });
          commit("setLoading", false);
        })
        .catch((err) => {
          reject(err);
          commit("setLoading", false);
          this._vm.$toast.error(Object.values(err.data.errors).join('\r\n'));
          commit("modal/setModalState", false, { root: true });
        });
    });
  },
};

export const mutations = {
  setLoading(state, payload) {
    state.loading = payload;
  }
};

export const getters = {
  getLoading(state) {
    return state.loading;
  }
};
